// extracted by mini-css-extract-plugin
export var labelWrapper = "_ex-0";